<mat-progress-bar
  *ngIf="isLoading === true"
  mode="indeterminate"
  color="accent"
></mat-progress-bar>
<div class="main-container">
  <div class="user-selection-container">
    <div class="sub-header">
      <div class="company">
        <label class="size" for="company">{{ "company" | translate }}: </label>
        <mat-form-field>
          <input
            matInput
            [matAutocomplete]="auto"
            id="company"
            type="text"
            (keyup)="searchEvent($event)"
            [(ngModel)]="company"
          />
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option *ngIf="noResults === false" value="">{{
              "none" | translate
            }}</mat-option>
            <mat-option *ngIf="noResults === true" value=""
              ><span class="no-results">No Results</span></mat-option
            >
            <mat-option
              class="company-select"
              *ngFor="let option of companies"
              [value]="option"
              (click)="selectCompany()"
            >
              <span>{{ option.customerName | titlecase }}</span>
              <span> - {{ option.holdingAccountNumber }}</span>
              <div>
                <span *ngIf="option.holdingSectorNumber !== null">
                  {{ option.holdingSectorNumber }}</span
                >
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="branch">
        <label class="size" for="branch">{{ "branch" | translate }}: </label>
        <mat-form-field>
          <mat-select [(ngModel)]="branch">
            <mat-option
              *ngFor="let branch of branches"
              (click)="selectBranch()"
              [value]="branch"
            >
              <span
                >{{ branch.primaryCity | titlecase }},
                {{ branch.primaryState | uppercase }}</span
              >
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="user">
        <label class="size" for="user">{{ "user" | translate }}: </label>
        <mat-form-field>
          <input
            matInput
            type="text"
            id="user"
            [(ngModel)]="userSearch"
            (keyup)="searchUsers($event)"
          />
          <button
            mat-button
            *ngIf="userSearch"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
  <mat-divider class="section-divide"></mat-divider>
  <div class="user-header-container" *ngIf="contentLoaded()">
    <div class="space"></div>
    <div class="permission-category-container">
      <h6 *ngFor="let permission of permissions">{{ permission.name }}</h6>
    </div>
  </div>
  <div class="users-container" *ngFor="let user of users; let i = index">
    <div
      class="user-edit"
      *ngIf="contentLoaded()"
      [ngClass]="{ activeRow: isEdit === true && userIndex === i }"
    >
      <button
        mat-icon-button
        class="edit-button"
        (click)="editUser(i)"
        *ngIf="(!isEdit && userIndex !== i) || (isEdit && userIndex !== i)"
      >
        <mat-icon aria-label="Example icon-button with a heart icon"
          >edit</mat-icon
        >
      </button>
      <button
        mat-icon-button
        class="submit-button"
        (click)="saveUserChanges(i, user)"
        *ngIf="isEdit === true && userIndex === i"
      >
        <mat-icon>done_all</mat-icon>
      </button>
      <h4>{{ user.firstName }} {{ user.lastName }}</h4>
    </div>
    <div
      class="permission-container"
      *ngIf="
        branchPermissionsIsDone === true &&
        userPermissionsIsDone === true &&
        noUserPermissions === false &&
        noBranchPermissions === false
      "
    >
      <div
        class="permission"
        *ngFor="let permission of permissions"
        [ngClass]="{ activeRow: isEdit === true && userIndex === i }"
      >
        <mat-checkbox
          [disabled]="
            (!isEdit && userIndex !== i) || (isEdit && userIndex !== i)
          "
          [checked]="isChecked(user.userId, permission, i)"
          (change)="checkboxSelected($event, permission, user)"
        >
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
<div class="no-program" *ngIf="noBranchPermissions === true">
  <h2>Sorry</h2>
  <p>This branch is not a part of a partner program.</p>
</div>
<div
  class="no-program"
  *ngIf="noUserPermissions === true && noBranchPermissions === false"
>
  <h2>Sorry</h2>
  <p>This branch currently does not have any users.</p>
</div>
